import { getCanvasInitialConfig } from '@/app/modules/seating/shared/domain/seatAllocator/canvas/getCanvasInitialConfig';
import {
    calculateSeatDimensions,
    getBoundariesByObjects,
} from '@/app/modules/seating/shared/domain/seatAllocator/canvas/calculations';

export const trimSeatPlanObjectsCoords = (seatPlan, gridConfig) => {
    const seatDimensions = calculateSeatDimensions(gridConfig ?? getCanvasInitialConfig().grid);
    const allSeats = seatPlan.blocks.flatMap((block) => block.rows.flatMap((row) => row.seats));
    const { left, top } = getBoundariesByObjects([...allSeats, ...(seatPlan.images ?? [])]);

    const offsetLeft = left + seatDimensions.width / 2;
    const offsetTop = top + seatDimensions.height / 2;

    const seatPlanCopy = {
        ...seatPlan,
        images:
            seatPlan.images?.map((image) => ({
                ...image,
                x: image.x - offsetLeft,
                y: image.y - offsetTop,
            })) ?? [],
        blocks: seatPlan.blocks.map((block) => ({
            ...block,
            rows: block.rows.map((row) => ({
                ...row,
                seats: row.seats.map((seat) => ({
                    ...seat,
                    x: seat.x - offsetLeft,
                    y: seat.y - offsetTop,
                })),
            })),
        })),
    };

    if (seatPlanCopy.starting_point) {
        seatPlanCopy.starting_point.x = seatPlanCopy.starting_point.x - left;
        seatPlanCopy.starting_point.y = seatPlanCopy.starting_point.y - top;
    }

    return seatPlanCopy;
};
